/* eslint-disable */
import axios from 'axios';

axios.defaults.baseURL = process.env.VUE_APP_TEAMIO_API_URL

export default {

    namespaced: true,
    state: {
    },

    mutations: {
    },

    actions: {
        async sendAction({commit, dispatch}, payload) {
            console.log(`In sendAction, received payload: ${JSON.stringify(payload)}`);
            try {
                dispatch('alert/setLoading', true, {root: true});                
                let response = await axios.post('/sendAction', payload, { crossdomain: true });
                console.log(`response is ${JSON.stringify(response.data)}`);                
                dispatch('alert/setLoaded', true, {root: true});
                dispatch('alert/setMessage', response, {root: true});
                //dispatch('alert/setDismissSuccessCountDown', 3, {root: true});
                return response;
            } catch(err) {
                console.log('Error sending action:', err);
                dispatch('alert/setErrored', true, {root: true});
                dispatch('alert/setMessage', err, {root: true});
                
                // Return error response with detailed logs for frontend processing
                // The error response structure: err.response.data contains the detailed logs
                if (err.response && err.response.data) {
                    return {
                        status: err.response.status,
                        data: err.response.data // This contains detailedLogs and executionSummary
                    };
                }
                
                // Fallback for network errors or other issues
                return {
                    status: 500,
                    data: {
                        message: err.message || 'Network error',
                        detailedLogs: [`[${new Date().toISOString()}] [ERROR] Frontend error: ${err.message || 'Unknown error'}`],
                        executionSummary: {
                            action: payload.action || 'Unknown',
                            siteID: payload.siteID || 'Unknown',
                            timestamp: new Date().toISOString(),
                            status: 'ERROR',
                            logCount: 1
                        }
                    }
                };
            }
        },

        async addCustomer( {commit, dispatch}, payload) {
            try {
                dispatch('alert/setLoading', true, {root: true});
                let response = await axios.post(`/addCustomer`, payload, { crossdomain: true });
                dispatch('alert/setLoaded', true, {root: true});
                dispatch('alert/setMessage', response, {root: true});
                //dispatch('alert/setDismissSuccessCountDown', 3, {root: true});
                return response;
            }
            catch(err) {
                console.log('Error adding a new customer:', err);
                dispatch('alert/setErrored', true, {root: true});
                dispatch('alert/setMessage', err, {root: true});

                // Normalize error response structure for callers
                if (err.response && err.response.status) {
                    return {
                        status: err.response.status,
                        data: err.response.data
                    };
                }
                // Network or CORS errors
                return {
                    status: 0,
                    data: { message: err.message || 'Network error' }
                };
            }
        },

        // Get deactivation status for a site (two-phase deactivation tracking)
        async getDeactivationStatus({commit, dispatch}, payload) {
            try {
                let response = await axios.post('/getDeactivationStatus', payload, { crossdomain: true });
                return response;
            } catch(err) {
                console.log('Error getting deactivation status:', err);
                if (err.response && err.response.status) {
                    return {
                        status: err.response.status,
                        data: err.response.data
                    };
                }
                return {
                    status: 0,
                    data: { message: err.message || 'Network error' }
                };
            }
        },

        // Resume a failed deactivation from where it left off
        async resumeDeactivation({commit, dispatch}, payload) {
            try {
                dispatch('alert/setLoading', true, {root: true});
                let response = await axios.post('/resumeDeactivation', payload, { crossdomain: true });
                dispatch('alert/setLoaded', true, {root: true});
                return response;
            } catch(err) {
                console.log('Error resuming deactivation:', err);
                dispatch('alert/setErrored', true, {root: true});
                dispatch('alert/setMessage', err, {root: true});
                if (err.response && err.response.status) {
                    return {
                        status: err.response.status,
                        data: err.response.data
                    };
                }
                return {
                    status: 0,
                    data: { message: err.message || 'Network error' }
                };
            }
        },

        // Cancel a pending deactivation (before Phase 2 runs)
        async cancelDeactivation({commit, dispatch}, payload) {
            try {
                dispatch('alert/setLoading', true, {root: true});
                let response = await axios.post('/cancelDeactivation', payload, { crossdomain: true });
                dispatch('alert/setLoaded', true, {root: true});
                return response;
            } catch(err) {
                console.log('Error canceling deactivation:', err);
                dispatch('alert/setErrored', true, {root: true});
                dispatch('alert/setMessage', err, {root: true});
                if (err.response && err.response.status) {
                    return {
                        status: err.response.status,
                        data: err.response.data
                    };
                }
                return {
                    status: 0,
                    data: { message: err.message || 'Network error' }
                };
            }
        },
    }
}